import { render, staticRenderFns } from "./WsTextButton001.vue?vue&type=template&id=e2c16066"
import script from "./WsTextButton001.vue?vue&type=script&lang=js"
export * from "./WsTextButton001.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports